<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-12">
        <Forms
          ref="frmGroup"
          :title="'CONFIGURÇÃO AMBIENTE'"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="clearInputs"
          v-on:Save="submitFile"
        >
          <div>
            <h4>Tela de Login:</h4>
            <hr />
            <div style="display: flex; gap: 1.5rem">
              <FormulateInput
                class="lg-formulate-input"
                v-model="posicao"
                placeholder="Selecione a posição"
                label="Posição do Menu de Login:"
                type="select"
                :options="['ESQUERDA', 'CENTRO', 'DIREITA']"
                name="logoPosition"
              />
              <div style="display: flex; width: 50%; gap: 1rem">
                <NxInput
                  v-model="background"
                  @input="uploadBackground"
                  label="Selecione Imagem de Fundo:"
                  type="file"
                  name="backgroundImage"
                  validation="mime:image/jpeg,image/png"
                  :validation-messages="this.imagemFundoValidationMessage"
                />
                <NxInput
                  v-model="logo"
                  @input="uploadLogo"
                  label="Selecione a Logo:"
                  type="file"
                  name="logoImage"
                  validation="mime:image/png"
                  :validation-messages="this.logoValidationMessage"
                />
              </div>
            </div>
          </div>
          <div style="margin-top: 1rem">
            <h4>Gestão de acesso:</h4>
            <hr />
            <FormulateInput
              class="lg-formulate-input"
              v-model="tipoPermissao"
              placeholder="Selecione o tipo de gestão"
              label="Selecione o tipo de gestão:"
              type="select"
              :options="this.gestaoOptions"
              name="tipoPermissao"
            />
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchSuperTela">Liberar supertela em associado?</label>
              <ToogleSwitch
                id="ToogleSwitchSuperTela"
                v-model="enableAssociateResume"
              />
            </div>
          </div>
          <div style="margin-top: 1rem">
            <h4>Gestão de Atendimento</h4>
            <hr />
            <FormulateInput
              class="lg-formulate-input"
              v-model="tipoAtendimento"
              placeholder="O cooperado será atendido por..."
              label="Selecione o tipo de gestão:"
              type="select"
              :options="{
                CENTRAL_PA: 'PELA CENTRAL DO PA',
                AGENTE_RELACIONAMENTO: 'PELO AGENTE DE RELACIONAMENTO',
                GERENTE_CARTEIRA: 'PELO GERENTE DA CARTEIRA'
              }"
              name="tipoAtendimento"
            />
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchNPS">O usuário deve ter NPS?</label>
              <ToogleSwitch
                id="ToogleSwitchNPS"
                v-model="npsStatus"
              />
            </div>
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchPA">Identificar PA pelo documento?</label>
              <ToogleSwitch
                id="ToogleSwitchPA"
                v-model="identificarPa"
              />
            </div>
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchAudio">Liberar audio?</label>
              <ToogleSwitch
                id="ToogleSwitchAudio"
                v-model="enableAudioAtendimento"
              />
            </div>
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchMensagens"
                >Mensagens Automáticas (Boas vindas e horário)?</label
              >
              <ToogleSwitch
                id="ToogleSwitchMensagens"
                v-model="mensagensAutomaticas"
              />
            </div>
          </div>
          <div
            style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
          >
            <div style="width: 100%">
              <label for="ToogleSwitchMensagens"
                >Identificar PA Pelo Celular?</label
              >
              <ToogleSwitch
                id="ToogleSwitchMensagens"
                v-model="identifyPaNumber"
              />
            </div>
          </div>
          <div style="margin-top: 3rem">
            <h4>Configurações de senha:</h4>
            <hr />
            <div style="display: flex; width: 100%; gap: 1rem">
              <div style="width: 100%">
                <label for="ToogleSwitchPassword"
                  >A senha dos usuários deve expirar periodicamente?</label
                >
                <ToogleSwitch
                  id="ToogleSwitchPassword"
                  v-model="passwordWillExpire"
                />
              </div>
              <FormulateInput
                class="lg-formulate"
                v-if="passwordWillExpire"
                v-model="daysToExpire"
                label="Qual o período em dias?"
                type="range"
                name="range"
                min="15"
                max="180"
                validation="required|min:15|max:180"
                :validation-messages="this.periodoValidationMessage"
                error-behavior="live"
                :show-value="true"
              />
            </div>
            <div
              style="display: flex; width: 100%; gap: 1rem; margin-top: 1.5rem"
            >
              <div style="width: 100%">
                <label for="ToogleSwitchBlocked"
                  >O usuário deve ter sua conta bloqueada após múltiplas
                  tentativas incorretas?</label
                >
                <ToogleSwitch
                  id="ToogleSwitchBlocked"
                  v-model="accountWillBlock"
                />
              </div>
              <FormulateInput
                class="lg-formulate"
                v-if="accountWillBlock"
                v-model="attemptsToBlock"
                label="Qual o número máximo de tentativas?"
                type="range"
                name="range"
                min="3"
                max="10"
                validation="required|min:3|max:10"
                :validation-messages="this.tentativasValidationMessage"
                error-behavior="live"
                :show-value="true"
              />
            </div>
            <div style="margin-top: 1rem">
              <FormulateInput
                class="lg-formulate-input"
                @change="hasClasseA($event.target.value)"
                v-model="typeSenderMFA"
                placeholder="Selecione o tipo de envio do MFA"
                label="Selecione o tipo de envio do MFA:"
                type="select"
                :options="{ EMAIL: 'EMAIL', SMS: 'SMS' }"
                name="typeSenderMFA"
              />
            </div>
          </div>
        </Forms>
      </div>
    </div>
    <div v-if="hasWaitUpload">
      <div class="upload"></div>
      <div class="uploadText">
        <h2>
          <i class="fas fa-file-import"></i> Upload iniciado! <br />Aguarde um
          momento, por favor.<br />
          <small style="font-size: 12px; padding-top: 10px"
            >Essa mensagem será fechada ao final!</small
          >
        </h2>
      </div>
      <div class="upload-loading">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="upload-loading-img"
          width="200px"
          height="200px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <g transform="translate(20 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#006a5b"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.375s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
          <g transform="translate(40 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#04a791"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.25s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
          <g transform="translate(60 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#abbd81"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.125s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
          <g transform="translate(80 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#d1ddb5"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="0s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
        </svg>
        <div class="text-center">
          <strong>Acompanhe abaixo o envio do arquivo:</strong>
          <url
            class="pt-3"
            v-for="(obj, index) in uploadingFiles"
            :key="index"
          >
            <li
              v-if="obj.uploaded"
              class="pt-2"
            >
              <i class="far fa-file-excel excel-color"></i> {{ obj.file.name }}
              <i class="fas fa-check excel-color"></i>
            </li>
            <li
              v-else
              class="pt-2"
            >
              <i class="fas fa-upload text-third"></i> Enviando
              {{ obj.file.name }}
              <b-spinner
                small
                label="Aguarde..."
                variant="success"
              ></b-spinner>
            </li>
          </url>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import EnvironmentRepository from '@/shared/http/repositories/access/environment'
import ParametroClasseA from '@/shared/http/repositories/configurations/parametroClasseA'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'Environment',
  mixins: [ActionsForm],
  data () {
    return {
      background: null,
      logo: null,
      posicao: null,
      tipoPermissao: null,
      tipoAtendimento: null,
      passwordWillExpire: false,
      daysToExpire: null,
      accountWillBlock: false,
      enableAssociateResume: false,
      npsStatus: false,
      identificarPa: false,
      enableAudioAtendimento: true,
      mensagensAutomaticas: false,
      identifyPaNumber: false,
      attemptsToBlock: null,
      typeSenderMFA: null,
      imagemFundoValidationMessage: {
        mime: 'A imagem deve estar em JPEG ou PNG'
      },
      logoValidationMessage: {
        mime: 'A imagem deve estar em PNG'
      },
      gestaoOptions: {
        GERENTE: this.$t('associates.gerenteSisbr').toUpperCase(),
        GERENTERELACIONAMENTO: 'GERENTE RELACIONAMENTO'
      },
      periodoValidationMessage: {
        required: 'Escolha o período em dias.',
        min: 'Mínimo de 15 dias'
      },
      tentativasValidationMessage: {
        required: 'Escolha a quantidade limite.',
        min: 'Mínimo de 3 tentativas'
      }
    }
  },
  components: {
    ToogleSwitch
  },
  computed: {
    hasWaitUpload () {
      return this.waitUpload
    }
  },
  created () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      EnvironmentRepository.getEnv()
        .then((res) => {
          let response = res.data

          this.posicao = response.posicao
          this.tipoPermissao = response.tipoPermissao
          this.tipoAtendimento = response.tipoAtendimento
          this.npsStatus = response.npsStatus === 1
          this.enableAssociateResume = response.enableAssociateResume
          this.identificarPa = response.identificarPa === 1
          this.enableAudioAtendimento = response.enableAudioAtendimento
          this.mensagensAutomaticas = response.mensagensAutomaticas === 1
          this.identifyPaNumber = response.identifyPaNumber === 1
          this.background = response.hasBackground
          this.logo = response.hasLogo

          // BACK RETURNS DAYS > 0 IF THE FEAT IS ON
          if (response.daysPwdExpire > 0) {
            this.passwordWillExpire = true
            this.daysToExpire = response.daysPwdExpire
          }
          if (response.maxLoginAttempts > 0) {
            this.accountWillBlock = true
            this.attemptsToBlock = response.maxLoginAttempts
          }

          this.typeSenderMFA = response.typeSenderMFA
        })
        .catch((err) => console.error(err))
    },
    uploadBackground () {
      if (!this.background) return
      this.background = this.background.files[0].file
    },
    uploadLogo () {
      if (!this.logo) return
      this.logo = this.logo.files[0].file
    },
    submitFile () {
      this.waitUpload = true
      const formData = new FormData()
      const importData = {
        posicao: this.posicao,
        tipoPermissao: this.tipoPermissao,
        tipoAtendimento: this.tipoAtendimento,
        daysPwdExpire:
          this.daysToExpire && this.passwordWillExpire ? this.daysToExpire : 0,
        maxLoginAttempts:
          this.attemptsToBlock && this.accountWillBlock
            ? this.attemptsToBlock
            : 0,
        hasBackground: true,
        enableAssociateResume: this.enableAssociateResume,
        npsStatus: this.npsStatus ? 1 : 0,
        enableAudioAtendimento: this.enableAudioAtendimento,
        identificarPa: this.identificarPa ? 1 : 0,
        mensagensAutomaticas: this.mensagensAutomaticas ? 1 : 0,
        identifyPaNumber: this.identifyPaNumber ? 1 : 0,
        hasLogo: true,
        typeSenderMFA: this.typeSenderMFA
      }
      let json = new Blob([JSON.stringify(importData)], {
        type: 'application/json'
      })

      if (this.background) formData.append('background', this.background)
      if (this.logo) formData.append('logo', this.logo)
      formData.append('data', json)

      EnvironmentRepository.Update(formData)
        .then(() => {
          toast.success('Ambiente alterado')
          this.$router.replace({ name: 'PaginaInicial' })
        })
        .catch(this.onException)
    },
    clearInputs () {
      this.logo = null
      this.background = null
      this.tipoPermissao = null
      this.tipoAtendimento = null
      this.posicao = 'ESQUERDA'
      this.typeSenderMFA = null
      this.enableAssociateResume = false
      this.npsSatus = false
      this.identificarPa = false
      this.enableAudioAtendimento = false
      this.mensagensAutomaticas = false
      this.identifyPaNumber = false
    },
    hasClasseA (val) {
      if (val === 'SMS') {
        ParametroClasseA.GetAll().then((response) => {
          if (!response.data || !response.data.usuario) {
            toast.warning('Parametros de Classe A não cadastrados no sistema')
            this.typeSenderMFA = 'EMAIL'
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.lg-formulate {
  width: 100% !important;
}
.formulate-input {
  width: 50%;
}
.formulate-input-element {
  max-width: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/environment/envinronment.vue